import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-6eb9e892"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "single-choice"
};
var _hoisted_2 = {
  "class": "radio-group"
};
var _hoisted_3 = ["onClick"];
var _hoisted_4 = {
  "class": "img-warp"
};
var _hoisted_5 = ["src", "onClick"];
import { ref } from 'vue';
import { useQuestion } from '@/hooks/useQuestion';
import { ErrorCode } from '@/types';
import { showImagePreview } from 'vant';
import { nodeList } from '@/utils/answer';
import DTitle from '@/components/DTitle.vue';
import { getOptionsExceptOther } from '@/utils/tools';
import { getChoiceConditions } from '@/utils/jump';
export default /*#__PURE__*/_defineComponent({
  __name: 'ImageChoice',
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose;
    var _useQuestion = useQuestion(),
      options = _useQuestion.options,
      is_necessary = _useQuestion.is_necessary,
      question_id = _useQuestion.question_id,
      content = _useQuestion.content,
      is_random = _useQuestion.is_random;
    var realOptions = is_random ? getOptionsExceptOther(options) : options;
    var _content$max = content.max,
      max = _content$max === void 0 ? undefined : _content$max,
      _content$min = content.min,
      min = _content$min === void 0 ? undefined : _content$min;
    var choice = ref([]);
    var node = nodeList.find(question_id);
    if (node) {
      choice.value = node.value.position;
    }
    var onChecked = function onChecked(value) {
      var _choice$value;
      if ((_choice$value = choice.value) !== null && _choice$value !== void 0 && _choice$value.includes(value)) {
        choice.value = choice.value.filter(function (item) {
          return item !== value;
        });
      } else {
        var _choice$value2;
        choice.value = [].concat(_toConsumableArray((_choice$value2 = choice.value) !== null && _choice$value2 !== void 0 ? _choice$value2 : []), [value]);
      }
    };
    var onPreview = function onPreview(src) {
      showImagePreview({
        images: [src],
        closeable: true
      });
    };
    __expose({
      validate: function () {
        var _validate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!(is_necessary && choice.value.length === 0)) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return", {
                  status: false,
                  code: ErrorCode.Necessary
                });
              case 2:
                if (!(max && choice.value.length > max)) {
                  _context.next = 4;
                  break;
                }
                return _context.abrupt("return", {
                  status: false,
                  code: ErrorCode.Max,
                  num: max
                });
              case 4:
                if (!(min && choice.value.length < min && choice.value.length > 0)) {
                  _context.next = 6;
                  break;
                }
                return _context.abrupt("return", {
                  status: false,
                  code: ErrorCode.Min,
                  num: min
                });
              case 6:
                return _context.abrupt("return", _objectSpread({
                  status: true,
                  data: {
                    question_id: question_id,
                    position: _toConsumableArray(choice.value),
                    answer: undefined
                  }
                }, getChoiceConditions(content, choice.value)));
              case 7:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function validate() {
          return _validate.apply(this, arguments);
        }
        return validate;
      }()
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(DTitle), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(realOptions), function (item) {
        return _openBlock(), _createElementBlock("div", {
          key: item.position_id,
          "class": "radio"
        }, [_createElementVNode("div", {
          "class": _normalizeClass(["icon", {
            active: choice.value.includes(item.position_id)
          }]),
          onClick: _withModifiers(function ($event) {
            return onChecked(item.position_id);
          }, ["stop"])
        }, null, 10, _hoisted_3), _createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
          src: item.image,
          alt: "",
          onClick: _withModifiers(function ($event) {
            return onPreview(item.image);
          }, ["stop"])
        }, null, 8, _hoisted_5)])]);
      }), 128))])]);
    };
  }
});